export const BASE_SIZE = 1024;
export const BASE_SIZE_FONT = (BASE_SIZE / 1024) * 86;
